// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2BPAf","info":"UpdateTermsInfo_info__10q31"};